<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Use Shared Pass</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <label for="searchCustomersInput">Search Customers</label>
      <input type="text" class="form-control" id="searchCustomersInput"
             ngbAutofocus
             [(ngModel)]="search"
             (ngModelChange)="handleCustomerFilterChange()">
    </div>

    <!-- Add a fixed-height div to prevent the input from shifting as results are loaded -->
    <div class="mt-3 mb-3" style="height: 231px;overflow-y: auto"
         *ngIf="!customerSelected">

      <ng-container *ngIf="hasSearchInput()">

        <table class="table table-bordered table-hover">
          <tbody *ngIf="!customerResultsPresent()">
            <tr>
              <td colspan="99">
                {{ loadingCustomers ? 'Loading...' : 'No results' }}
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="customerResultsPresent()">
            <tr style="cursor:pointer"
                *ngFor="let customer of filteredCustomerResults()"
                (click)="selectRelatedCustomer(customer)">
              <td>
                {{ customer.first_name }} {{ customer.last_name }}
                <span class="text-muted">
                  {{ dateStringFromISO8601(customer.birthday )}}
                  <span *ngIf="customer.email">- {{ customer.email }}</span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="alert alert-info" *ngIf="!loadingCustomers && hasRecentActivityFilter()">
          Only recently-active customers are being shown.
          <a href="#" (click)="$event.preventDefault(); handleExpandSearch();">
            Expand search to all customers.
          </a>
        </div>

      </ng-container>

    </div>

    <div class="mt-3 mb-3" *ngIf="customerSelected">
      <p class="text-muted" *ngIf="loadingPasses">Loading passes...</p>
      <ng-container *ngIf="!loadingPasses">
        <p *ngIf="!passResultsPresent()">Selected customer has no usable passes</p>
        <ng-container *ngIf="passResultsPresent()">
          <div *ngFor="let pass of filteredPassResults(); let passIdx = index">
            <table>
              <tr>
                <td class="pr-2">Pass Name:</td>
                <td>{{ pass.name }}</td>
              </tr>
              <tr>
                <td class="pr-2">Balance:</td>
                <td>{{ pass.number_of_uses_remaining }} entries</td>
              </tr>
              <tr>
                <td class="pr-2">Expiry Date:</td>
                <td *ngIf="pass.expiration_date">
                  {{ dateStringFromISO8601(pass.expiration_date) }}
                </td>
                <td class="text-muted" *ngIf="!pass.expiration_date">None</td>
              </tr>
            </table>
            <button class="btn btn-primary btn-block mt-2"
                    (click)="passChosenCallback(pass.id);activeModal.close()">
              Use Pass
            </button>
            <hr *ngIf="passIdx < (passList.results.length - 1)">
          </div>
        </ng-container>
      </ng-container>
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
  </div>

</ng-container>
